module.exports = __webpack_public_path__ + "static/img/tb-shopping-cart.8d57a2fd.svg";